module.exports = __webpack_public_path__ + "static/CircularStd-Book-7f0da7e125865f311954b7ea46a2c198.woff2";